import { CardContent, Grid, Paper, Typography } from '@material-ui/core';
import { TextFieldFastField } from '../../../components';
import React from 'react';
import useStyles from './sampleDevelopmentNl.style';
import SampleDevelopmentNlSpecCustomerGrp from './SampleDevelopmentNlSpecCustomerGrp';
import SampleDevelopmentNlSpecDetail from './SampleDevelopmentNlSpecDetail';
import SampleDevelopmentNlSpecLabelDimension from './SampleDevelopmentNlSpecLabelDimension';
import SampleDevelopmentNlSpecSubstrate from './SampleDevelopmentNlSpecSubstrate';
import SampleDevelopmentNlSpecSubstrateInfo from './SampleDevelopmentNlSpecSubstrateInfo';

interface SampleDevelopmentNlSpecProps {
  isCrtLocked?: boolean;
  values: any;
  handleChange: any;
  errors: any;
  setFieldValue: any;
}

const SampleDevelopmentNlSpec: React.FC<SampleDevelopmentNlSpecProps> = (props) => {
  const { values, handleChange, setFieldValue, isCrtLocked = false } = props;
  const classes = useStyles();

  return (
    <Paper variant="outlined">
      <Typography className={classes.title}>Specification</Typography>
      <CardContent>
        <SampleDevelopmentNlSpecLabelDimension isCrtLocked={isCrtLocked} />

        <SampleDevelopmentNlSpecDetail isCrtLocked={isCrtLocked} />

        <SampleDevelopmentNlSpecSubstrate
          isCrtLocked={isCrtLocked}
          values={values}
          handleChange={handleChange}
          setFieldValue={setFieldValue}
        />

        <SampleDevelopmentNlSpecCustomerGrp isCrtLocked={isCrtLocked} />

        <SampleDevelopmentNlSpecSubstrateInfo isCrtLocked={isCrtLocked} />
        <Grid
          container
          spacing={1}
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Typography className={classes.title}>4. Special Requirement</Typography>
          <Grid item xs={12} sm={8}>
            <TextFieldFastField
              disabled={isCrtLocked}
              className={classes.textInput}
              name="specialRequirementData"
              label="Special Requirement"
              variant="outlined"
              margin="dense"
              fullWidth
            />
          </Grid>
        </Grid>
      </CardContent>
    </Paper>
  );
};

export default SampleDevelopmentNlSpec;
